import { computed, DestroyRef, Signal, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

import { ISessionParking } from '@pkp/models';
import { SessionsService } from '@pkp/services';
import { canInterrupt } from './interrupt-refund';
import { sessionState, sessionUntil } from './session-state';

export function createSessionProgress(
  session: Signal<ISessionParking>,
  sessionsService: SessionsService,
  destroyRef: DestroyRef,
): {
  progressBar: Signal<number>;
  remainingTime: Signal<string>;
  until: Signal<string>;
  isActive: Signal<boolean>;
  isPending: Signal<boolean>;
  canInterrupt: Signal<boolean>;
} {
  const tick = signal(0);
  interval(30_000)
    .pipe(takeUntilDestroyed(destroyRef))
    .subscribe(() => {
      tick.update(v => v + 1);
    });

  const progressBar = computed(() => {
    tick();
    const s = session();
    return sessionsService.percentTime(s.start_time, s.stop_time);
  });

  const remainingTime = computed(() => {
    tick();
    return sessionsService.remainingTime(session().stop_time);
  });

  // «до 31.12.2029, 23:30» — по Алматы, год календарный (A14)
  const until = computed(() => sessionUntil(session().stop_time));

  // START — «Оформляется…», без кнопок; кнопки — только у идущей (не START, окончание впереди)
  const state = computed(() => {
    tick();
    return sessionState(session(), Date.now());
  });
  const isActive = computed(() => state() === 'active');
  const isPending = computed(() => state() === 'pending');

  const interruptible = computed(() => canInterrupt(session()));

  return { progressBar, remainingTime, until, isActive, isPending, canInterrupt: interruptible };
}
